import { arrayAnnotationDate, truncatedPeriodAnnotation } from "utils/periods";
export default function timelineXAxisLabels(date, periodType, cutLabel, forceShowFull) {
  if (cutLabel) return "";
  var labelArray = arrayAnnotationDate(periodType, date);
  switch (labelArray === null || labelArray === void 0 ? void 0 : labelArray[0]) {
    case "Q1":
    case "T1":
    case "Januari":
    case "H1":
      return truncatedPeriodAnnotation(periodType, labelArray);
    default:
      return forceShowFull ? truncatedPeriodAnnotation(periodType, labelArray) : labelArray === null || labelArray === void 0 ? void 0 : labelArray[0].toString();
  }
}